import React, { useState, useEffect, useRef } from "react"; // useRef add kiya autofocus ke liye
import axios from "axios";
import { useDispatch } from "react-redux";
import { closeAllModals } from "../../redux/authSlice";
import { useNavigate } from "react-router-dom";
import APIURL from "../../common/Config";
import ApiManagerCustomer from "../../api-manager/ApiManagerCustomer.component";
import { encodeRequestData } from "../../utils/apiSecurity";
import toast from "react-hot-toast";
import "./CustomerRegistration.css";

const CustomerRegistrationForm = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [isMobileVerified, setIsMobileVerified] = useState(
    localStorage.getItem("isOtpVerified") === "true",
  );
  // const [isEmailVerified, setIsEmailVerified] = useState(localStorage.getItem("isEmailVerified") === "true");
  const [isEmailVerified, setIsEmailVerified] = useState(
    localStorage.getItem("isEmailVerified") === "true",
  );

  const [showMobileOtp, setShowMobileOtp] = useState(false);
  const [showEmailOtp, setShowEmailOtp] = useState(false);

  const [mobileOtp, setMobileOtp] = useState(["", "", "", ""]);
  const [emailOtp, setEmailOtp] = useState(["", "", "", "", "", ""]);

  // Refs for auto-focus and backspace logic
  const mobileRefs = useRef([]);
  const emailRefs = useRef([]);

  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    country: "",
    countryName: "",
    state: "",
    stateName: "",
    city: "",
    cityName: "",
    dob: "",
    timeOfBirth: "",
    location: "",
    email: localStorage.getItem("userEmail") || "",
    mobile: localStorage.getItem("phoneNumber") || "",
    pinCode: "",
  });

  useEffect(() => {
    if (isOpen) {
      const fetchCountries = async () => {
        try {
          const res = await axios.get(`${APIURL}/api/country/countryList`);
          setCountries(
            res.data.map((c) => ({ id: c.id, name: c.country_name })),
          );
        } catch (e) {
          toast.error("Error fetching countries");
        }
      };
      fetchCountries();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleCountryChange = async (e) => {
    const id = e.target.value;
    const name = e.target.options[e.target.selectedIndex].text;
    setFormData({
      ...formData,
      country: id,
      countryName: name,
      state: "",
      city: "",
    });
    try {
      const res = await axios.get(`${APIURL}/api/states/${id}`);
      setStates(res.data.map((s) => ({ id: s.state_id, name: s.state_name })));
    } catch (e) {
      setStates([]);
    }
  };

  const handleStateChange = async (e) => {
    const id = e.target.value;
    const name = e.target.options[e.target.selectedIndex].text;
    setFormData({ ...formData, state: id, stateName: name, city: "" });
    try {
      const res = await axios.get(`${APIURL}/api/cities/${id}`);
      setCities(res.data.map((c) => ({ id: c.city_id, name: c.city_name })));
    } catch (e) {
      setCities([]);
    }
  };

  const triggerVerify = async (type) => {
    const value = type === "mobile" ? formData.mobile : formData.email;
    if (!value) return toast.error(`Please enter ${type}`);

    setLoading(true);
    try {
      if (type === "mobile") {
        const payload = encodeRequestData({
          requestType: "SEND-OTP",
          msisdn: value,
          timeStamp: new Date().toISOString(),
        });
        const res = await axios.post(`${APIURL}/otp/service`, payload);
        localStorage.setItem("otpSessionId", res.data.otpSessionId);
        setShowMobileOtp(true);
      } else {
        await axios.post(
          `https://heastro.in/heastro-service/otp/generate-email-otp?email=${value}`,
        );
        setShowEmailOtp(true);
      }
      toast.success("Verification code sent!");
    } catch (e) {
      toast.error("Failed to send code");
    } finally {
      setLoading(false);
    }
  };

  // --- REFINED OTP LOGIC (BACKSPACE & AUTO-FOCUS) ---
  const handleOtpChange = (type, index, value) => {
    if (isNaN(value)) return;
    const isMobile = type === "mobile";
    const otpArray = isMobile ? [...mobileOtp] : [...emailOtp];
    const refs = isMobile ? mobileRefs : emailRefs;

    otpArray[index] = value;
    isMobile ? setMobileOtp(otpArray) : setEmailOtp(otpArray);

    // Auto-focus next
    if (value !== "" && index < (isMobile ? 3 : 5)) {
      refs.current[index + 1].focus();
    }
  };

  const handleOtpKeyDown = (type, index, e) => {
    const isMobile = type === "mobile";
    const otpArray = isMobile ? [...mobileOtp] : [...emailOtp];
    const refs = isMobile ? mobileRefs : emailRefs;

    if (e.key === "Backspace") {
      if (otpArray[index] === "" && index > 0) {
        // Focus previous and clear it
        refs.current[index - 1].focus();
        otpArray[index - 1] = "";
        isMobile ? setMobileOtp(otpArray) : setEmailOtp(otpArray);
      } else {
        // Just clear current
        otpArray[index] = "";
        isMobile ? setMobileOtp(otpArray) : setEmailOtp(otpArray);
      }
    }
  };

  const handleVerifyOtp = async (type) => {
    const code = type === "mobile" ? mobileOtp.join("") : emailOtp.join("");
    const requiredLength = type === "mobile" ? 4 : 6;

    if (code.length < requiredLength)
      return toast.error(`Please enter ${requiredLength} digit OTP`);

    setLoading(true);
    try {
      if (type === "mobile") {
        const payload = encodeRequestData({
          requestType: "VALIDATE-OTP",
          msisdn: formData.mobile,
          otpPin: code,
          otpSessionId: localStorage.getItem("otpSessionId"),
        });
        const res = await axios.post(`${APIURL}/otp/service`, payload);
        if (res.data.status === "SUCCESS") {
          setIsMobileVerified(true);
          setShowMobileOtp(false);
          toast.success("Mobile Verified!");
        } else {
          toast.error("Invalid OTP");
        }
      } else {
        const res = await axios.post(
          `https://heastro.in/heastro-service/otp/verify-email?email=${formData.email}&otp=${code}`,
        );
        if (res.data.success.includes("verified")) {
          setIsEmailVerified(true);
          setShowEmailOtp(false);
          toast.success("Email Verified!");
        } else {
          toast.error("Invalid OTP");
        }
      }
    } catch (e) {
      toast.error("Verification failed");
    } finally {
      setLoading(false);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!isMobileVerified || !isEmailVerified)
  //     return toast.error("Please verify both Mobile and Email");

  //   setLoading(true);
  //   const payload = {
  //     firstName: formData.name,
  //     gender: formData.gender,
  //     dob: formData.dob,
  //     timeOfBirth: "00:00",
  //     mobile: formData.mobile,
  //     email: formData.email,
  //     birthCity: formData.cityName,
  //     latitude: "0.0",
  //     regDate: new Date().toISOString(),
  //     birthState: formData.stateName,
  //     country: formData.countryName,
  //     birthCityId: formData.city,
  //     birthStateId: formData.state,
  //     countryId: formData.country,
  //     pinCode: formData.pinCode,
  //     status: 0,
  //   };
  //   try {
  //     const response = await ApiManagerCustomer.registerAsCustomer(payload);
  //     if (response.id > 0) {
  //       localStorage.setItem("isLoggedIn", "true");
  //       localStorage.setItem("userData", JSON.stringify(response));
  //       toast.success("Welcome aboard!");
  //       dispatch(closeAllModals());
  //       navigate("/");
  //     }
  //   } catch (error) {
  //     toast.error("Internal Server Error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isMobileVerified || !isEmailVerified) return toast.error("Please verify both Mobile and Email");
    
    setLoading(true);

    // EXACT SWAGGER FORMAT (UI ki saari fields ke saath)
    const payload = {
      firstName: formData.name,            // UI: Full Name
      gender: formData.gender.toUpperCase(), // UI: Gender (Swagger needs Uppercase)
      dob: formData.dob,                   // UI: DOB
      timeOfBirth: formData.timeOfBirth || "00:00", // UI Field (Defaulting to 00:00 if empty)
      mobile: formData.mobile,             // UI: Mobile
      email: formData.email,               // UI: Email
      birthCity: formData.cityName,        // UI: City Name
      birthState: formData.stateName,      // UI: State Name
      birthPlace: formData.cityName,       // Swagger Required Field
      country: formData.countryName,       // UI: Country Name
      pinCode: parseInt(formData.pinCode), // UI: Pin Code (Ensuring Integer)
      // appName: "ASTROBHAGYA2026",          // THE FIX: Yeh backend ko free credit rokne ko bolega
      
      // Additional internal fields for DB consistency
      birthCityId: formData.city,
      birthStateId: formData.state,
      countryId: formData.country,
      status: 0,
      regDate: new Date().toISOString()
    };

    console.log("Final Payload Sending to Backend:", payload); // Debug ke liye check karna

    try {
      const response = await ApiManagerCustomer.registerAsCustomer(payload);
      if (response.id > 0) {
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("userData", JSON.stringify(response));
        toast.success("Welcome aboard!");
        dispatch(closeAllModals()); 
        navigate("/");
      } else {
        toast.error("Registration failed. Please try again.");
      }
    } catch (error) {
      console.error("Registration Error:", error);
      toast.error("Internal Server Error");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="auth-overlay scrollable-container">
      <div className="cosmic-nebula"></div>
      <div className="cosmic-stars"></div>
      <div className="shooting-star"></div>

      <div className="reg-modern-card glass-morph">
        <button className="close-x" onClick={onClose}>
          &times;
        </button>

        <div className="ab-logo-universe-box">
          <img
            src={require("../../assets/AstrobhagyaLogoo.webp")}
            alt="logo"
            className="m-logo animated-logo"
          />
          <img
            src={require("../../assets/AstrobhagyaName.webp")}
            alt="name"
            className="m-name"
          />
        </div>

        <h2 className="reg-title">Complete Profile</h2>
        <p className="reg-subtitle">Complete your cosmic profile to continue</p>

        <form className="reg-form-grid" onSubmit={handleSubmit}>
          <div className="input-group-full">
            <label>Full Name</label>
            <input
              type="text"
              placeholder="Enter Full Name"
              required
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
            />
          </div>

          <div className="input-group-half">
            <label>Mobile Number</label>
            <div className="verify-input-wrapper">
              <input
                type="tel"
                value={formData.mobile}
                placeholder="10 Digit Number"
                readOnly={isMobileVerified || showMobileOtp}
                onChange={(e) =>
                  setFormData({ ...formData, mobile: e.target.value })
                }
              />
              {!isMobileVerified && !showMobileOtp && (
                <button
                  type="button"
                  className="btn-verify-small"
                  onClick={() => triggerVerify("mobile")}
                >
                  Verify
                </button>
              )}
              {isMobileVerified && (
                <span className="verified-label">Verified ✅</span>
              )}
            </div>
            {showMobileOtp && !isMobileVerified && (
              <div className="inline-otp-section animated-fade">
                <div className="otp-row-cosmic compact">
                  {mobileOtp.map((d, i) => (
                    <input
                      key={i}
                      ref={(el) => (mobileRefs.current[i] = el)}
                      maxLength={1}
                      type="text"
                      inputMode="numeric"
                      className="otp-input-cosmic mini"
                      value={d}
                      onChange={(e) =>
                        handleOtpChange("mobile", i, e.target.value)
                      }
                      onKeyDown={(e) => handleOtpKeyDown("mobile", i, e)}
                    />
                  ))}
                  <button
                    type="button"
                    className="inline-confirm-btn"
                    onClick={() => handleVerifyOtp("mobile")}
                  >
                    OK
                  </button>
                  <button
                    type="button"
                    className="edit-text-btn"
                    onClick={() => setShowMobileOtp(false)}
                  >
                    Edit
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="input-group-half">
            <label>Email ID</label>
            <div className="verify-input-wrapper">
              <input
                type="email"
                value={formData.email}
                placeholder="email@example.com"
                readOnly={isEmailVerified || showEmailOtp}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
              />
              {!isEmailVerified && !showEmailOtp && (
                <button
                  type="button"
                  className="btn-verify-small"
                  onClick={() => triggerVerify("email")}
                >
                  Verify
                </button>
              )}
              {isEmailVerified && (
                <span className="verified-label">Verified ✅</span>
              )}
            </div>
            {showEmailOtp && !isEmailVerified && (
              <div className="inline-otp-section animated-fade">
                <div className="otp-row-cosmic compact">
                  {emailOtp.map((d, i) => (
                    <input
                      key={i}
                      ref={(el) => (emailRefs.current[i] = el)}
                      maxLength={1}
                      type="text"
                      inputMode="numeric"
                      className="otp-input-cosmic mini"
                      value={d}
                      onChange={(e) =>
                        handleOtpChange("email", i, e.target.value)
                      }
                      onKeyDown={(e) => handleOtpKeyDown("email", i, e)}
                    />
                  ))}
                  <button
                    type="button"
                    className="inline-confirm-btn"
                    onClick={() => handleVerifyOtp("email")}
                  >
                    OK
                  </button>
                  <button
                    type="button"
                    className="edit-text-btn"
                    onClick={() => setShowEmailOtp(false)}
                  >
                    Edit
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="input-group-half">
            <label>Gender</label>
            <select
              required
              value={formData.gender}
              onChange={(e) =>
                setFormData({ ...formData, gender: e.target.value })
              }
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div className="input-group-half">
            <label>Pin Code</label>
            <input
              type="text"
              required
              placeholder="6 Digit Code"
              value={formData.pinCode}
              onChange={(e) =>
                setFormData({ ...formData, pinCode: e.target.value })
              }
            />
          </div>

          <div className="input-group-half">
            <label>Country</label>
            <select
              required
              value={formData.country}
              onChange={handleCountryChange}
            >
              <option value="">Select Country</option>
              {countries.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>
          <div className="input-group-half">
            <label>State</label>
            <select
              required
              value={formData.state}
              onChange={handleStateChange}
            >
              <option value="">Select State</option>
              {states.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select>
          </div>

          <div className="input-group-half">
            <label>City</label>
            <select
              required
              value={formData.city}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  city: e.target.value,
                  cityName: e.target.options[e.target.selectedIndex].text,
                })
              }
            >
              <option value="">Select City</option>
              {cities.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>
          <div className="input-group-half">
            <label>DOB</label>
            <input
              type="date"
              required
              value={formData.dob}
              onChange={(e) =>
                setFormData({ ...formData, dob: e.target.value })
              }
            />
          </div>

          <button
            type="submit"
            className={`m-continue reg-submit-btn ${!isMobileVerified || !isEmailVerified ? "locked-btn" : ""}`}
            disabled={loading || !isMobileVerified || !isEmailVerified}
          >
            {loading
              ? "PROCESSING..."
              : !isMobileVerified || !isEmailVerified
                ? "VERIFY BOTH TO REGISTER"
                : "REGISTER"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CustomerRegistrationForm;
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useDispatch } from "react-redux";
// import { closeAllModals } from "../../redux/authSlice";
// import { useNavigate } from "react-router-dom";
// import APIURL from "../../common/Config";
// import ApiManagerCustomer from "../../api-manager/ApiManagerCustomer.component";
// import { encodeRequestData } from "../../utils/apiSecurity";
// import toast from "react-hot-toast";
// import "./CustomerRegistration.css";

// const CustomerRegistrationForm = ({ isOpen, onClose }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false);
//   const [countries, setCountries] = useState([]);
//   const [states, setStates] = useState([]);
//   const [cities, setCities] = useState([]);

//   // --- LOGIC: Check who is verified from previous step ---
//   const [isMobileVerified, setIsMobileVerified] = useState(localStorage.getItem("isOtpVerified") === "true");
//   const [isEmailVerified, setIsEmailVerified] = useState(localStorage.getItem("isEmailVerified") === "true");

//   const [showMobileOtp, setShowMobileOtp] = useState(false);
//   const [showEmailOtp, setShowEmailOtp] = useState(false);

//   const [mobileOtp, setMobileOtp] = useState(["", "", "", ""]);
//   const [emailOtp, setEmailOtp] = useState(["", "", "", "", "", ""]); // 6 Digits for Email

//   const [formData, setFormData] = useState({
//     name: "", gender: "", country: "", countryName: "", state: "", stateName: "",
//     city: "", cityName: "", dob: "", timeOfBirth: "", location: "",
//     email: localStorage.getItem("userEmail") || "",
//     mobile: localStorage.getItem("phoneNumber") || "",
//     pinCode: "",
//   });

//   useEffect(() => {
//     if (isOpen) {
//       const fetchCountries = async () => {
//         try {
//           const res = await axios.get(`${APIURL}/api/country/countryList`);
//           setCountries(res.data.map((c) => ({ id: c.id, name: c.country_name })));
//         } catch (e) { toast.error("Error fetching countries"); }
//       };
//       fetchCountries();
//     }
//   }, [isOpen]);

//   if (!isOpen) return null;

//   const handleCountryChange = async (e) => {
//     const id = e.target.value;
//     const name = e.target.options[e.target.selectedIndex].text;
//     setFormData({ ...formData, country: id, countryName: name, state: "", city: "" });
//     try {
//       const res = await axios.get(`${APIURL}/api/states/${id}`);
//       setStates(res.data.map((s) => ({ id: s.state_id, name: s.state_name })));
//     } catch (e) { setStates([]); }
//   };

//   const handleStateChange = async (e) => {
//     const id = e.target.value;
//     const name = e.target.options[e.target.selectedIndex].text;
//     setFormData({ ...formData, state: id, stateName: name, city: "" });
//     try {
//       const res = await axios.get(`${APIURL}/api/cities/${id}`);
//       setCities(res.data.map((c) => ({ id: c.city_id, name: c.city_name })));
//     } catch (e) { setCities([]); }
//   };

//   const triggerVerify = async (type) => {
//     const value = type === "mobile" ? formData.mobile : formData.email;
//     if (!value) return toast.error(`Please enter ${type}`);

//     setLoading(true);
//     try {
//       if (type === "mobile") {
//         const payload = encodeRequestData({ requestType: "SEND-OTP", msisdn: value, timeStamp: new Date().toISOString() });
//         const res = await axios.post(`${APIURL}/otp/service`, payload);
//         localStorage.setItem("otpSessionId", res.data.otpSessionId);
//         setShowMobileOtp(true);
//       } else {
//         await axios.post(`https://heastro.in/heastro-service/otp/generate-email-otp?email=${value}`);
//         setShowEmailOtp(true);
//       }
//       toast.success("Verification code sent!");
//     } catch (e) { toast.error("Failed to send code"); }
//     finally { setLoading(false); }
//   };

//   const handleVerifyOtp = async (type) => {
//     const code = type === "mobile" ? mobileOtp.join("") : emailOtp.join("");
//     const requiredLength = type === "mobile" ? 4 : 6;

//     if (code.length < requiredLength) return toast.error(`Please enter ${requiredLength} digit OTP`);

//     setLoading(true);
//     try {
//       if (type === "mobile") {
//         const payload = encodeRequestData({ requestType: "VALIDATE-OTP", msisdn: formData.mobile, otpPin: code, otpSessionId: localStorage.getItem("otpSessionId") });
//         const res = await axios.post(`${APIURL}/otp/service`, payload);
//         if (res.data.status === "SUCCESS") {
//           setIsMobileVerified(true);
//           setShowMobileOtp(false);
//           toast.success("Mobile Verified!");
//         } else { toast.error("Invalid OTP"); }
//       } else {
//         const res = await axios.post(`https://heastro.in/heastro-service/otp/verify-email?email=${formData.email}&otp=${code}`);
//         if (res.data.success.includes("verified")) {
//           setIsEmailVerified(true);
//           setShowEmailOtp(false);
//           toast.success("Email Verified!");
//         } else { toast.error("Invalid OTP"); }
//       }
//     } catch (e) { toast.error("Verification failed"); }
//     finally { setLoading(false); }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!isMobileVerified || !isEmailVerified) return toast.error("Please verify both Mobile and Email");

//     setLoading(true);
//     const payload = {
//       firstName: formData.name, gender: formData.gender, dob: formData.dob,
//       timeOfBirth: "00:00", mobile: formData.mobile, email: formData.email,
//       birthCity: formData.cityName, latitude: "0.0", regDate: new Date().toISOString(),
//       birthState: formData.stateName, country: formData.countryName,
//       birthCityId: formData.city, birthStateId: formData.state, countryId: formData.country,
//       pinCode: formData.pinCode, status: 0,
//     };
//     try {
//       const response = await ApiManagerCustomer.registerAsCustomer(payload);
//       if (response.id > 0) {
//         localStorage.setItem("isLoggedIn", "true");
//         localStorage.setItem("userData", JSON.stringify(response));
//         toast.success("Welcome aboard!");
//         dispatch(closeAllModals());
//         navigate("/");
//       }
//     } catch (error) { toast.error("Internal Server Error"); }
//     finally { setLoading(false); }
//   };

//   return (
//     <div className="auth-overlay scrollable-container">
//       <div className="cosmic-nebula"></div>
//       <div className="cosmic-stars"></div>

//       <div className="reg-modern-card glass-morph">
//         <button className="close-x" onClick={onClose}>&times;</button>

//         <div className="ab-logo-universe-box">
//           <img src={require("../../assets/AstrobhagyaLogoo.webp")} alt="logo" className="m-logo animated-logo" />
//           <img src={require("../../assets/AstrobhagyaName.webp")} alt="name" className="m-name" />
//         </div>

//         <h2 className="reg-title">Complete Profile</h2>
//         <p className="reg-subtitle">Complete your cosmic profile to continue</p>

//         <form className="reg-form-grid" onSubmit={handleSubmit}>
//           <div className="input-group-full">
//             <label>Full Name</label>
//             <input type="text" placeholder="Enter Full Name" required value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
//           </div>

//           {/* Mobile Field with Verified Check */}
//           <div className="input-group-half">
//             <label>Mobile Number</label>
//             <div className="verify-input-wrapper">
//               <input type="tel" value={formData.mobile} readOnly={isMobileVerified || showMobileOtp} onChange={(e) => setFormData({ ...formData, mobile: e.target.value })} />
//               {!isMobileVerified && !showMobileOtp && <button type="button" className="btn-verify-small" onClick={() => triggerVerify('mobile')}>Verify</button>}
//               {isMobileVerified && <span className="verified-label">Verified ✅</span>}
//             </div>
//             {showMobileOtp && !isMobileVerified && (
//               <div className="inline-otp-section animated-fade">
//                 <div className="otp-row-cosmic compact">
//                   {mobileOtp.map((d, i) => (
//                     <input key={i} maxLength={1} type="text" className="otp-input-cosmic mini" value={d} onChange={(e) => {
//                       let n = [...mobileOtp]; n[i] = e.target.value; setMobileOtp(n);
//                       if (e.target.value && i < 3) e.target.parentElement.childNodes[i+1].focus();
//                     }} />
//                   ))}
//                   <button type="button" className="inline-confirm-btn" onClick={() => handleVerifyOtp('mobile')}>OK</button>
//                   <button type="button" className="edit-text-btn" onClick={() => setShowMobileOtp(false)}>Edit</button>
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Email Field with Verified Check & 6 Digit OTP */}
//           <div className="input-group-half">
//             <label>Email ID</label>
//             <div className="verify-input-wrapper">
//               <input type="email" value={formData.email} readOnly={isEmailVerified || showEmailOtp} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
//               {!isEmailVerified && !showEmailOtp && <button type="button" className="btn-verify-small" onClick={() => triggerVerify('email')}>Verify</button>}
//               {isEmailVerified && <span className="verified-label">Verified ✅</span>}
//             </div>
//             {showEmailOtp && !isEmailVerified && (
//               <div className="inline-otp-section animated-fade">
//                 <div className="otp-row-cosmic compact">
//                   {emailOtp.map((d, i) => (
//                     <input key={i} maxLength={1} type="text" className="otp-input-cosmic mini" value={d} onChange={(e) => {
//                       let n = [...emailOtp]; n[i] = e.target.value; setEmailOtp(n);
//                       if (e.target.value && i < 5) e.target.parentElement.childNodes[i+1].focus();
//                     }} />
//                   ))}
//                   <button type="button" className="inline-confirm-btn" onClick={() => handleVerifyOtp('email')}>OK</button>
//                   <button type="button" className="edit-text-btn" onClick={() => setShowEmailOtp(false)}>Edit</button>
//                 </div>
//               </div>
//             )}
//           </div>

//           <div className="input-group-half"><label>Gender</label>
//             <select required value={formData.gender} onChange={(e) => setFormData({ ...formData, gender: e.target.value })}>
//               <option value="">Select Gender</option><option value="Male">Male</option><option value="Female">Female</option><option value="Other">Other</option>
//             </select>
//           </div>
//           <div className="input-group-half"><label>Pin Code</label>
//             <input type="text" required placeholder="6 Digit Code" value={formData.pinCode} onChange={(e) => setFormData({ ...formData, pinCode: e.target.value })} />
//           </div>

//           <div className="input-group-half"><label>Country</label>
//             <select required value={formData.country} onChange={handleCountryChange}>
//               <option value="">Select Country</option>
//               {countries.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
//             </select>
//           </div>
//           <div className="input-group-half"><label>State</label>
//             <select required value={formData.state} onChange={handleStateChange}>
//               <option value="">Select State</option>
//               {states.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
//             </select>
//           </div>

//           <div className="input-group-half"><label>City</label>
//             <select required value={formData.city} onChange={(e) => setFormData({ ...formData, city: e.target.value, cityName: e.target.options[e.target.selectedIndex].text })}>
//               <option value="">Select City</option>
//               {cities.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
//             </select>
//           </div>
//           <div className="input-group-half"><label>DOB</label>
//             <input type="date" required value={formData.dob} onChange={(e) => setFormData({ ...formData, dob: e.target.value })} />
//           </div>

//           <button type="submit" className={`m-continue reg-submit-btn ${(!isMobileVerified || !isEmailVerified) ? 'locked-btn' : ''}`} disabled={loading || !isMobileVerified || !isEmailVerified}>
//             {loading ? "PROCESSING..." : ((!isMobileVerified || !isEmailVerified) ? "VERIFY BOTH TO REGISTER" : "REGISTER")}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default CustomerRegistrationForm;
